import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// DataV 大屏组件库
import dataV from '@jiaminghi/data-view'

// 全局样式
import './assets/css/index.scss'

Vue.use(ElementUI)
Vue.use(dataV)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
